import React from "react";
import { Box, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./home.css"


const ImageCarousel = ({ items }) => {
    return (
        <Box className="carousel-container" sx={{height: '100%'}}>
            <Swiper
                modules={[Navigation, Autoplay]}
                navigation                
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                loop={true}
                style={{ width: "100%", height: "100%" }}
                 className="swiperFix"
            >
                {items.map((item, i) => (
                    <SwiperSlide key={i}>
                        <Box className="imageContainer">
                            <Box
                                component="img"
                                src={item.image}
                                alt={item.title}
                                className="carouselImage"
                            />
                            <Typography variant="label" className="imageTitle">
                                {item.title}
                            </Typography>
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default ImageCarousel;
